/**
 * Реєстр документів амортизації (Підпорція 1.2, 2026-05-25).
 *
 * List + кнопка Calculate-for-period (з period inputs + force_recreate).
 */
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import DataTable, { type ColumnDef } from '@/shared/components/DataTable';
import {
  depreciationCalculation,
  type DepreciationCalculation,
} from '@/api/depreciation';


const fmt2 = (v: string | number) =>
  Number(v).toLocaleString('uk-UA', {
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  });


export function DepreciationCalculationPage() {
  const list = useQuery({
    queryKey: ['depreciation-calc'],
    queryFn: () => depreciationCalculation.list({ limit: 200 }),
  });
  const cols = useMemo<ColumnDef<DepreciationCalculation>[]>(
    () => [
      { key: 'document_number', header: '№', width: 150, importBadge: true, sortValue: (r) => r.document_number ?? '', cell: (r) => r.document_number },
      { key: 'period_year', header: 'Рік', width: 90, sortValue: (r) => r.period_year, cell: (r) => r.period_year },
      { key: 'period_month', header: 'Місяць', width: 100, sortValue: (r) => r.period_month, cell: (r) => r.period_month },
      { key: 'items_count', header: 'Активів', width: 110, align: 'right', sortValue: (r) => r.items_count, cell: (r) => r.items_count },
      { key: 'total_amount', header: 'Сума', width: 150, align: 'right', sortValue: (r) => Number(r.total_amount), cell: (r) => fmt2(r.total_amount) },
      { key: 'skipped_count', header: 'Пропущено', width: 130, align: 'right', sortValue: (r) => r.skipped_count, cell: (r) => r.skipped_count },
      { key: 'trigger_source', header: 'Тригер', width: 150, sortValue: (r) => r.trigger_source ?? '', cell: (r) => r.trigger_source },
      { key: 'posted', header: 'Проведено', width: 120, align: 'center', sortValue: (r) => (r.posted ? 1 : 0), cell: (r) => (r.posted ? '✓ так' : 'ні') },
    ],
    [],
  );
  return (
    <>
      <div className="toolbar">
        <h2 style={{ margin: 0 }}>Амортизація</h2>
        <span style={{ marginLeft: 'auto', color: '#666' }}>
          Усього: {list.data?.total ?? 0}
        </span>
      </div>
      <DataTable<DepreciationCalculation>
        rows={list.data?.items ?? []}
        columns={cols}
        rowKey={(r) => r.id}
        loading={list.isLoading}
        emptyText="Немає документів."
        rowMuted={(r) => (r.deletion_mark ? 0.4 : undefined)}
        initialSortKey="document_number"
        initialSortDir="desc"
      />
    </>
  );
}
